<template>
<v-card tile class='pb-3'>
  <v-card-title v-if='title' class='overline py-0 pr-0' >
    <v-btn icon small
      v-if='withReload'
      @click='get' :loading='request.loading'
      class='mr-2' ><v-icon small >mdi-reload</v-icon>
    </v-btn>
    {{title}}
    <v-spacer></v-spacer>
    <v-btn-toggle v-if='cardItem && listItem' tile v-model="view">
        <v-btn value='list' >
          <v-icon>mdi-format-list-text</v-icon>
        </v-btn>
        <v-btn value='card' >
          <v-icon>mdi-view-grid</v-icon>
        </v-btn>
    </v-btn-toggle>
    <slot name='title-right' ></slot>
    <v-btn text icon small
      v-if='helpText' color='info'
      @click='showHelpText=!showHelpText' >
      <v-icon small >mdi-information</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider />
  <request-status :request='req' :message200='false' />
  <v-alert text tile dismissible v-model='showHelpText'
    v-if='showHelpText' type='info' >{{ helpText }}
  </v-alert>
  <slot ></slot>
  <v-row v-if='view==="card"' >
    <template v-for='(item, index) in items' >
      <v-col
        v-if="groupByField && (index === 0 || item[groupByField] !== items[index-1][groupByField])"
        :key='`title-${item.id}-${index}`'
        cols=12 :class="{'pt-0': index===0}" >
        <slot
          name='group-title' :item='item' >
            <v-subheader class='overline' >{{ item[groupByField] }}</v-subheader>
        </slot>
      </v-col>
      <v-col :key='item.id' cols=12 sm=6 md=4 lg=3 xl=2  >
        <slot :name="`item-${item.id}`" :item='`${item}-card`'>
          <component :is='cardItem'
            v-if='listItem'
            v-bind='attrs'
            :key='item.id'
            :item='item'
            v-on="$listeners"
            class='ma-3'
            @reload="get"
            @selected="bubbleSelected"
            @edit="bubbleEdit" />
        </slot>
      </v-col>
    </template>
  </v-row>
  <v-list v-else class='mb-0 pa-0' >
    <template v-for='(item, index) in items' >
      <slot
        name='group-title'
        v-if="groupByField && (index === 0 || item[groupByField] !== items[index-1][groupByField])"
        :item='item' >
          <v-subheader class='overline' cols=12 >{{ item[groupByField] }}</v-subheader>
      </slot>

      <slot :name="`item-${item.id}`" :item='item'>
        <component :is='listItem'
          v-if='listItem'
          v-bind='attrs'
          :key='item.id'
          :item='item'
          v-on="$listeners"
          @reload="get"
          @selected="bubbleSelected"
          @edit="bubbleEdit" />
      </slot>

      <v-divider :key='`d-${item.id}`' ></v-divider>
    </template>
  </v-list>

  <template v-if='items.length === 0 && !request.loading' >
    <slot name='empty-text' >
      <v-list-item  >
        <v-list-item-content>
          <v-list-item-title>No items found</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action >
          <v-btn @click='$emit("new")' outlined small color='primary' >
            <v-icon small >mdi-plus</v-icon>
            New</v-btn>
        </v-list-item-action>
        <v-list-item-action >
          <v-btn @click='get' outlined small color='primary' >Refresh</v-btn>
        </v-list-item-action>
      </v-list-item>
    </slot>
  </template>

  <slot name='dialogs' ></slot>
</v-card>
</template>
<script>
export default {
  name: 'ListViewPage',
  props: {
    title: { type: String },
    helpText: { type: String },
    groupByField: { type: String },
    initialView: { type: String, default: 'list' },
    listItem: { type: Object, required: false },
    cardItem: { type: Object, required: false },
    request: { type: Object, required: true },
    attrs: { type: Object, default: () => {} },
    filter: { type: Function, required: false },
    touch: { type: Number, default: 0 },
    withReload: { type: Boolean, default: true },
    objectPath: { type: String, default: 'result.results' }
  },
  data () {
    return {
      showHelpText: false,
      view: 'list',
      req: {}
    }
  },
  mounted () {
    if (this.initialView) { this.view = this.initialView }
  },
  computed: {
    items () {
      let items = this.getObjectPath(this.req, this.objectPath, [])
      if (this.filter) {
        return this.filter(items)
      }
      return items
    }
  },
  watch: {
    req () {
      this.$emit('update:request', this.req)
    },
    touch () {
      this.get()
    },
    request: {
      immediate: true,
      handler () {
        if (this.request) { this.req = this.request }
        this.get()
      }
    }
  },
  methods: {
    get () { // debounce this
      this.$request('get', this.req)
    },
    bubbleSelected (val) {
      this.$emit('selected', val)
    },
    bubbleEdit (val) {
      this.$emit('edit', val)
    }
  }
}
</script>
